import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { ILDataUpload } from './il-data-upload';

export type IILWorkflowConnectProps = ReactRedux.DispatchProp<Redux.Action>;

export const ILDataUploadContainer: React.ComponentClass
  = ReactRedux.connect()(ILDataUpload);
